import { useModal } from '@gluedigital/modal'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { addVisit, getBusinessVisits, uploadImage } from 'src/store/actions/api'
import { useTiposVisita } from '../../../hooks/useTiposVisita'
import './UploadButton.sass'

const UploadButton = ({ locationId, visitId, type = 1, askType, ...other }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const modal = useModal()
  const tiposVisitaOptions = useTiposVisita()
  const [file, setFile] = useState(null)
  const [askExtraInfo, setAskExtraInfo] = useState(false)
  const [tiposVisita, setTiposVisita] = useState([])
  const [creating, setCreating] = useState(false)

  const filePickerRef = useRef(null)

  const handleCameraButtonClick = (e) => {
    e.stopPropagation()
    if (askType && !visitId) {
      setAskExtraInfo(true)
    } else {
      filePickerRef.current.click()
    }
  }

  const handleFileSelected = async (e) => {
    const fileList = e.target.files
    setFile(fileList[0])
    uploadFile(fileList[0])
  }

  const uploadFile = async (providedFile) => {
    const image = providedFile || file
    modal.show('upload-image-modal', { isLoading: true })

    try {
      let currentVisitId = visitId
      if (!currentVisitId) {
        const visit = await dispatch(addVisit(locationId, tiposVisita))
        currentVisitId = visit.id
      }

      const upload = await dispatch(uploadImage(locationId, currentVisitId, type, image, tiposVisita))
      const imageId = upload.imagen.id

      if (type === 3) {
        await dispatch(getBusinessVisits(locationId))
        history.push(`/location/${locationId}/history`)
      } else {
        history.push(`/location/${locationId}/photo/${imageId}`)
      }
      modal.show('upload-image-modal', { uploadError: false })
    } catch (err) {
      console.error('Error when trying to upload image:', err)
      modal.show('upload-image-modal', { uploadError: true })
    }
    setTimeout(() => {
      modal.hide('upload-image-modal')
    }, 2000)
  }

  const handleContinue = async () => {
    if (creating) return
    if (tiposVisita.length < 1) {
      alert('Debes seleccionar un tipo de visita')
      return
    }

    const isValtrack = tiposVisita[0] === 'Valtrack técnico'

    if (isValtrack) {
      setCreating(true)
      setAskExtraInfo(false)
      try {
        modal.show('upload-image-modal', { isLoading: true })
        const visit = await dispatch(addVisit(locationId, tiposVisita))
        await dispatch(getBusinessVisits(locationId))
        modal.hide('upload-image-modal')
        history.push(`/location/${locationId}/visit/${visit.id}/technical-labors`)
      } catch (err) {
        console.error('Error creating Valtrack visit:', err)
        setCreating(false)
        setAskExtraInfo(true)
        modal.show('upload-image-modal', { uploadError: true })
        setTimeout(() => {
          modal.hide('upload-image-modal')
        }, 2000)
      }
    } else {
      setAskExtraInfo(false)
      filePickerRef.current.click()
    }
  }

  const handleCancel = () => {
    setAskExtraInfo(false)
    setTiposVisita([])
  }

  const isSelected = (item) => {
    return tiposVisita.includes(item)
  }

  const handleToggleSelect = (item) => {
    setTiposVisita([item])
  }

  return (
    <>
      {askExtraInfo ? (
        <div className="upload-image-modal">
          <div className="content">
            <h2>Tipo de visita</h2>
            <div className="list-options">
              {tiposVisitaOptions.tiposVisitaList.map((t) => (
                <div
                  key={t.id}
                  onClick={() => handleToggleSelect(t.nombre)}
                  className={isSelected(t.nombre) ? 'option selected' : 'option'}
                >
                  <span>{t.nombre}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 15 }}>
              <button className="cancel" onClick={handleCancel} disabled={creating}>
                Cancelar
              </button>
              <button onClick={handleContinue} disabled={creating}>
                Continuar
              </button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div {...other} onClick={handleCameraButtonClick}>
        <input
          className="file-picker hidden"
          ref={filePickerRef}
          type="file"
          accept="image/*"
          onChange={handleFileSelected}
        />
      </div>
    </>
  )
}

UploadButton.propTypes = {
  locationId: PropTypes.number.isRequired,
  visitId: PropTypes.number,
  type: PropTypes.number,
  askType: PropTypes.bool
}

export default UploadButton
